// extracted by mini-css-extract-plugin
export default {"st0":"LogoWithText_st0__Ir7hc","st1":"LogoWithText_st1__ckIyB","cls2":"LogoWithText_cls2__AsqYE"};